<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="견적요청서 폼 조회"
      desc="저장한 견적요청서 폼의 내역을 확인할 수 있습니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                :items="tableItems"
                :filtered="filtered"
                :allCount="allCount"
                :filteredCount="filteredCount"
                @getData="getDataFromServer"
                @ordering="ordering"
                @selPageLength="selPageLength">

      <div slot="request_summary" slot-scope="props">
          <div v-for="(step,step_idx) in props.item.steps" :key="'step-'+step_idx">
            <div class="flex space-between"
                 style="text-align: left"
                 v-for="(form,form_idx) in step.forms"
                 :key="'form-'+form_idx">
              <div style="margin-right: 8px;">
                <span v-if="form.question!==''">{{ form.question }}</span>
                <span v-else>{{ typeName(form.type) }}</span>
              </div>
              <div>
                <div class="flex" style="width:85px">
                  <i style="font-size:1rem;margin-top:3px" class="material-icons">{{ iconName(form.type) }}</i>
                  <div>{{ typeName(form.type) }}</div>
                </div>
              </div>
            </div>
          </div>
      </div>

      <div slot="activate" slot-scope="props">
        <span v-if="props.item.activate">발행</span>
        <span v-else>미발행</span>
      </div>

      <div slot="modify_delete" slot-scope="props" style="display: inline-grid">
        <button class="button half" style="margin:2px 0" @click.stop.prevent="$router.push('form/create?id='+props.item.id)">수정</button>
        <button class="button half is-danger" style="margin:2px 0" @click.stop.prevent="delModal(props.item)">삭제</button>
        <button class="button half" style="margin:2px 0" @click.stop.prevent="duplicateItem(props.item)">복제</button>
      </div>
    </admin-table>


    <!--<sweet-modal overlay-theme="dark" ref="deleteModal">
      <lp-modal>
        <span slot="title"> </span>
        <span slot="desc"> 견적폼을 삭제하시겠습니까?</span>
        <span slot="ok" @click="deleteItem">확인</span>
        <span slot="cancel" @click="$refs.deleteModal.close()">취소</span>
      </lp-modal>
    </sweet-modal>-->

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'Form',
    mixins: [
      ListMixin
    ],

    created () {
      this.init();
    },

    data() {
      return {
        modalItem:0,
        els:[
          {
          icon:"short_text",
          id: 1,
          name: "단답형",
          types: "text",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"subject",
          id: 2,
          name: "장문형",
          types: "textarea",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"radio_button_checked",
          id: 3,
          name: "객관식 질문",
          types: "radio",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"check_box",
          id: 4,
          name: "체크박스",
          types: "checkbox",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"arrow_drop_down_circle",
          id: 5,
          name: "드롭다운",
          types: "dropdown",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"cloud_upload",
          id: 6,
          name: "파일 업로드",
          types: "fileupload",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"insert_invitation",
          id: 7,
          name: "날짜",
          types: "date",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"linear_scale",
          id: 8,
          name: "직선단계",
          types: "linear",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"access_time",
          id: 9,
          name: "시간",
          types: "time",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"place",
          id: 10,
          name: "지역",
          types: "region",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"person",
          id: 11,
          name: "사용자 정보",
          types: "users",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
          icon:"가능 지역",
          id: 12,
          name: "주소",
          types: "address",
          updated_date: "2018-01-12T08:30:33.585Z"
        },{
            icon: "looks_one",
            id: 13,
            name: "숫자 단답형",
            types: "number",
            updated_date: "2018-01-12T08:30:33.585Z"
          }
        ]
      }
    },


    methods: {
      init() {
        this.initializing('form', 'estimate/form');
      },
      getDataFromServer() {
        this.getData();
      },
      typeName(types) {
        return find(this.els, 'types', types).name;
      },
      iconName(types) {
        return find(this.els, 'types', types).icon;
      },
      // getData() {
      //   this.$axios.get(this.getUrl('estimate/form'), {
      //     params:this.filtered
      //   })
      //     .then(res => {
      //       if(res.status === 200){
      //         this.tableItems = res.data.data;
      //         this.filtered.page_length = res.data.page_length;
      //         this.filtered.cur_page = res.data.cur_page;
      //         this.pageCount = res.data.total_page;
      //         this.allCount = res.data.total_count;
      //         this.filteredCount = res.data.count;
      //       }
      //     });
      // },

      delModal(item){
        let value = {
          id: item.id,
          url: 'estimate/form/',
          title: '폼을 삭제하시겠습니까?'
        }
        this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
      },
      // 복제
      duplicateItem(item){
        let value = {
          url: 'estimate/form/' + item.id + '/duplicate'
        };
        this.$store.commit('openModal', {type: 'modal-duplicate-item', value: value});
      },
      deleteItem(){
        this.$axios.delete(this.getUrl('estimate/form/') + this.modalItem)
          .then(res => {
            if (res.status === 200) {
              this.$refs.deleteModal.close();
              this.getData();
              this.toast('견적폼이 삭제되었습니다.');
            }
          });
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

  .tr-whole-border th
    padding 12px 6px

  .many-field-tr td
    padding 6px

  .lp-form-type
    color #787878
    display table-cell
    font-size 0.8rem

  .table-cell
    text-align left
    width 100%
</style>
